// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navigation .v-toolbar__content {\n  padding-left: 0;\n}\n.main-title {\n  background-color: #ffe1ce;\n  font-size: 28pt;\n  line-height: 28pt;\n  font-weight: 550;\n  color: #ff6600;\n}", ""]);
// Exports
module.exports = exports;
